export default __webpack_public_path__ + "static/media/carciofo2.7be65ccb.png";